// extracted by mini-css-extract-plugin
export var menuIcon = "_nl-0";
export var menuIconInline = "_nl-1";